/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import axios from 'axios'
import { SettingsManager } from '../../configuration/SettingsManager'
import { IApiClient } from './IApiClient'
import { IUserSessionMiddleware } from '../middleware/UserSessionMiddleware/contracts'
import { injectProperty } from '../../configuration/ServiceLocator'
import { injectable } from 'inversify'
import { isObject } from 'util'

@injectable()
export class ApiClient implements IApiClient {
	baseUrl: string
	timeout: number

	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	constructor() {
		this.baseUrl = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}`
		this.timeout = SettingsManager.REACT_APP_MAIN_API_BASE_URL_REQUEST_TIMEOUT().value
	}

	graphQlWithAxios(query: string): Promise<any> {
		// return this.userSessionMiddleware
		//     .loadSessionJwt()
		//     .then(token => {
		const instance = axios.create({
			baseURL: this.baseUrl,
			timeout: this.timeout,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				// Authorization: `Bearer ${token}`,
			},
		})

		const instanceQuery = isObject(query)
			? query
			: JSON.stringify({
				query: query,
			  })

		return instance.post('', instanceQuery)
		// })
		//  .then((response) => {
		//      debugger;
		// })
	}

	getCMSToken(): Promise<string> {
		const cmsToken = localStorage.getItem(SettingsManager.REACT_APP_ProductCategories_TOKEN_NAME)
		return new Promise<string>(resolve => {
			resolve(JSON.stringify(cmsToken))
		})
	}
}
